import React from 'react';
import Icon from '../../../components/AppIcon';

const SelectionSummary = ({ selectedCount, totalFields, estimatedSize, rowLimit }) => {
  return (
    <div className="bg-surface border border-border rounded-lg p-6 shadow-soft">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
        {/* Selected Fields */}
        <div className="text-center">
          <div className="flex items-center justify-center mb-2">
            <Icon name="CheckSquare" size={24} className="text-primary" />
          </div>
          <div className="text-2xl font-bold text-text-primary">
            {selectedCount}
          </div>
          <div className="text-sm text-text-secondary">
            Campos seleccionados
          </div>
          <div className="text-xs text-text-secondary mt-1">
            de {totalFields} disponibles
          </div>
        </div>

        {/* Progress */}
        <div className="text-center">
          <div className="flex items-center justify-center mb-2">
            <Icon name="Target" size={24} className="text-secondary" />
          </div>
          <div className="text-2xl font-bold text-text-primary">
            {Math.round((selectedCount / totalFields) * 100)}%
          </div>
          <div className="text-sm text-text-secondary">
            Progreso
          </div>
          <div className="w-full bg-muted rounded-full h-2 mt-2">
            <div 
              className="bg-secondary h-2 rounded-full transition-all"
              style={{ width: `${(selectedCount / totalFields) * 100}%` }}
            ></div>
          </div>
        </div>

        {/* Estimated Size */}
        <div className="text-center">
          <div className="flex items-center justify-center mb-2">
            <Icon name="HardDrive" size={24} className="text-warning" />
          </div>
          <div className="text-2xl font-bold text-text-primary">
            {estimatedSize}
          </div>
          <div className="text-sm text-text-secondary">
            Tamaño estimado
          </div>
          <div className="text-xs text-text-secondary mt-1">
            Archivo final
          </div>
        </div>

        {/* Records Limit */}
        <div className="text-center">
          <div className="flex items-center justify-center mb-2">
            <Icon name="Database" size={24} className="text-success" />
          </div>
          <div className="text-2xl font-bold text-text-primary">
            {rowLimit === 0 ? '∞' : rowLimit?.toLocaleString('es-ES')}
          </div>
          <div className="text-sm text-text-secondary">
            Registros máximos
          </div>
          <div className="text-xs text-text-secondary mt-1">
            {rowLimit === 0 ? 'Sin límite' : 'Por archivo'}
          </div>
        </div>
      </div>

      {/* Compatibility Indicators */}
      <div className="flex flex-wrap gap-3 mt-6 pt-6 border-t border-border">
        <div className="flex items-center space-x-2 px-3 py-1 bg-success/10 text-success rounded-full">
          <Icon name="Check" size={14} />
          <span className="text-sm font-medium">Compatible MercadoLibre</span>
        </div>
        
        {selectedCount > 0 && (
          <div className="flex items-center space-x-2 px-3 py-1 bg-primary/10 text-primary rounded-full">
            <Icon name="Zap" size={14} />
            <span className="text-sm font-medium">Listo para exportar</span>
          </div>
        )}
        
        <div className="flex items-center space-x-2 px-3 py-1 bg-muted text-text-secondary rounded-full">
          <Icon name="Shield" size={14} />
          <span className="text-sm font-medium">Conexión segura AWS</span>
        </div>
      </div>
    </div>
  );
};

export default SelectionSummary;